<div class="border border-2 p-1 rounded white-bg shadow-kp absolute" *ngIf="show$|async" [style.left.px]="x" [style.top.px]="y"
  (click)="close()">
  <ng-content></ng-content>
</div>